// extracted by css-extract-rspack-plugin
module.exports =  {"grid":"Grid__grid--TbNFU","col2":"Grid__col2--vr7nC","colGap":"Grid__colGap--jS1M0"};